import React from "react";

export const MelcoUIApp: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <div >{children}</div>;   // No-op wrapper for v4
};

export default MelcoUIApp;